<ul class="product-preview-grid">
  @if (productsResource.isLoading()) {
    @for (skeleton of [1, 2, 3]; track skeleton) {
      <li><app-product-card-skeleton /></li>
    }
  } @else {
    @for (product of productsResource.value(); track product.id) {
      <li><app-product-card [product]="product" [isShowComparisonButton]="false" /></li>
    } @empty {
      <li class="product-preview-empty">{{ "common.form.template_placeholder.no_products_found" | translate }}</li>
    }
  }
</ul>
